import React, { Component, Fragment } from "react";
import { CommonTabs } from "../../TabBarCompoenent/CommonTabs";
import "./styles.css";
import Card from "../../LampAssets/CardView/Card";
import LocoOutOfUse from "images/ReVAMP/outOfUse.png";
import LocoCompliant from "images/ReVAMP/compliant.png";
import LocoNonCompliant from "images/ReVAMP/nonCompliant.png";
import DailyImg from "images/ReVAMP/dailyDueG.png";
import DailyImageDue from "images/ReVAMP/dailyDueBlack.png";
import momentTz from "moment-timezone";
import TooltipContainer from "../../../libraries/TooltipContainer";
import { languageService } from "../../../Language/language.service";
import { versionInfo } from "../../MainPage/VersionInfo";
import { CRUDFunction } from "../../../reduxCURD/container";
const CardNumberStyle = {
  fontWeight: "550",
  marginRight: "20px",
  fontSize: "20px",
  paddingBlock: "5px",
};
class AssetDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAsset: props.selectedAsset,
      attributes: [],
    };
    this.getComplianceStatus = this.getComplianceStatus.bind(this);
    this.getOOUStatus = this.getOOUStatus.bind(this);
    this.getDailyDueStatus = this.getDailyDueStatus.bind(this);
  }
  componentDidMount() {
    const { getAssetDetails, selectedAsset } = this.props;
    getAssetDetails && getAssetDetails(`type/${selectedAsset && selectedAsset.assetType}`);
  }
  componentDidUpdate(prevProps) {
    const { actionType, AssetDetails } = this.props;
    if (actionType !== prevProps.actionType && actionType === "ASSETDETAILS_READ_SUCCESS") {
      this.setState({
        attributes: AssetDetails && AssetDetails.lampAttributes && AssetDetails.lampAttributes.sort((a, b) => a.order - b.order),
      });
    }
  }
  getComplianceStatus(asset) {
    const { nonCompliant } = asset && asset.assetStates ? asset.assetStates : {};
    return nonCompliant;
  }
  getOOUStatus(asset) {
    const { outOfUse } = asset && asset.assetStates ? asset.assetStates : {};
    return outOfUse;
  }
  getDailyDueStatus(asset) {
    const dailyDueDate = asset && asset.assetStates && asset.assetStates.dailyDue ? asset.assetStates.dailyDue : null;
    const startOfDay = momentTz.tz("US/Eastern").startOf("day").format();
    const endOfDay = momentTz.tz("US/Eastern").endOf("day").format();
    return dailyDueDate >= startOfDay && dailyDueDate <= endOfDay ? true : false;
  }
  render() {
    const { selectedAsset } = this.props;
    const dailyCompleted = this.getDailyDueStatus(selectedAsset);
    const { attributes } = this.state;
    let list = processAttributesList(attributes, selectedAsset, false);
    return (
      <div className="VOU_Container">
        <h3 className="VOU_Header">ASSET DETAILS</h3>
        <div className="assetDetailViewContainer">
          <div className="assetSection">
            <div style={{ display: "flex", flexDirection: "row", marginBlockEnd: "20px", alignItems: "end" }}>
              <span>
                <strong>Unit ID:</strong> <span className="valueOfkey">{selectedAsset.unitId}</span>
              </span>
              {versionInfo.isReVAMP() && (
                <Fragment>
                  {this.getComplianceStatus(selectedAsset) ? (
                    <span style={{ marginInlineStart: "10px" }}>
                      <TooltipContainer tooltipText={languageService("Non Compliant")}>
                        <img style={{ width: "24px" }} src={LocoNonCompliant} alt={"loco status"} />
                      </TooltipContainer>
                    </span>
                  ) : (
                    <span style={{ marginInlineStart: "10px" }}>
                      <TooltipContainer tooltipText={languageService("Compliant")}>
                        <img style={{ width: "24px" }} src={LocoCompliant} alt={"loco status"} />
                      </TooltipContainer>
                    </span>
                  )}
                  {this.getOOUStatus(selectedAsset) ? (
                    <span style={{ marginInlineStart: "20px" }}>
                      <TooltipContainer tooltipText={languageService("Out of use")}>
                        <img style={{ width: "24px" }} src={LocoOutOfUse} alt={"out of use"} />
                      </TooltipContainer>
                    </span>
                  ) : (
                    !versionInfo.isDailyDisabled() && (
                      <span style={{ marginInlineStart: "20px" }}>
                        <TooltipContainer
                          tooltipText={languageService(dailyCompleted ? "Daily Inspection Completed" : "Daily Inspection Due")}
                        >
                          <img style={{ width: "24px" }} src={dailyCompleted ? DailyImg : DailyImageDue} alt={"daily"} />
                        </TooltipContainer>
                      </span>
                    )
                  )}
                </Fragment>
              )}
            </div>

            <div className="twoColumnLayout">
              {Object.entries({
                // "Unit ID": selectedAsset.unitId,
                "Asset Type": selectedAsset.assetType,
                Description: selectedAsset.description,
              }).map(([key, value]) => (
                <div key={key} className="columnItem">
                  <strong>{key}:</strong> {typeof value === "object" ? JSON.stringify(value) : value}
                </div>
              ))}
            </div>
          </div>

          <div className="assetSection">
            <div className="twoColumnLayout">
              {list.map((attribute) => {
                const { name, value } = attribute;
                return (
                  <div key={name} className="columnItem">
                    <strong>{name}:</strong>{" "}
                    {typeof value === "object"
                      ? JSON.stringify(value)
                      : ["Drilled", "Event Recorder (N/A)"].includes(name)
                        ? value
                          ? "Yes"
                          : "No"
                        : value}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const AssetDetailsContainer = CRUDFunction(
  AssetDetails,
  "AssetDetails",
  { create: false, update: false, read: true, delete: false },
  null,
  null,
  "assettype",
);
export default AssetDetailsContainer;
function processAttributesList(attributesList, asset, isPriority) {
  return attributesList
    .map((atr) => ({
      ...atr,
      key: atr.name,
      value: asset.attributes[atr.name],
    }))
    .sort((a, b) => {
      return a.order !== b.order ? a.order - b.order : a.name.localeCompare(b.name);
    });
}



// WEBPACK FOOTER //
// ./src/components/AssetView/AssetDetails/AssetDetails.jsx